export default "__VITE_ASSET__SIw5eYxM__"